import { render, staticRenderFns } from "./CourseViewHeader.vue?vue&type=template&id=55cc78c8&"
import script from "./CourseViewHeader.vue?vue&type=script&lang=js&"
export * from "./CourseViewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports